<template>
    <h2 v-if="type == 'external'">Search by Keyword</h2>
    <h2 v-if="type == 'internal'">Search by Part Number</h2>
</template>

<script>
    import { mapState } from 'vuex'
    /*on selector change mutate the search type*/
    export default {
        name: 'SearchSelectionPane',
        computed: {
            ...mapState({
                type: state => state.search.type,
            })
        },
        methods: {
            setType(newSearchType) {
                this.$store.commit('CHANGE_SEARCH_TYPE', newSearchType);
            }
        }
    };
</script>

<style scoped>
</style>